import { render } from "./BiJiView.vue?vue&type=template&id=30c23d6e&scoped=true&ts=true"
import script from "./BiJiView.vue?vue&type=script&lang=ts"
export * from "./BiJiView.vue?vue&type=script&lang=ts"

import "./BiJiView.vue?vue&type=style&index=0&id=30c23d6e&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\newbdb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c23d6e"]])

export default __exports__